import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { GrievanceNotificationItemData } from "@/services/sintegrada/grievanceNotificationItem/getGrievanceNotificationItems";
import { formatIdentifier } from "@/utils/formatIdentifier";
import { formatPatientAddress } from "@/utils/formatPatientAddress";

import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	isLoading: boolean;
	grievanceNotificationItemData: GrievanceNotificationItemData[];
};

export function GrievanceNotificationIndividualTable({
	grievanceNotificationItemData,
	isLoading,
}: Props) {
	return (
		<Table responsive bordered hover>
			<thead className="fw-bolder">
				<tr>
					<th className="text-center text-nowrap">Dt. da Notificação</th>
					<th className="text-center">Nome do paciente</th>
					<th className="text-center">CPF</th>
					<th className="text-center">Dt. Nasc.</th>
					<th className="text-center">Sexo</th>
					<th className="text-center">Endereço</th>
					<th className="text-center">Classificação</th>
					<th className="text-center">1º Sintoma</th>
					<th className="text-center">Notificação</th>
				</tr>
			</thead>
			<tbody>
				{grievanceNotificationItemData && !isLoading ? (
					grievanceNotificationItemData?.map((item, index) => {
						const { patient } = item;

						const formattedSymptomDate = item.firstSymptomAt
							? dayjs(item.firstSymptomAt).format("DD/MM/YYYY")
							: "N/A";
						
						const street = patient.street || "N/A";
						const houseNumber = patient.houseNumber || "N/A";
						const neighborhood = patient.neighborhoodText || "N/A";
						const city = patient.cityName || "N/A";
						const state = patient.uf || "N/A";
						const zipCode = patient.zipCode || "N/A";

						return (
							<tr key={`grievance-notification-item-data-${index}`}>
								<td title="Dt. da Notificação" className="text-center">
									{dayjs(item.notificationItemCreatedAt).format("DD/MM/YYYY HH:mm")}
								</td>
								<td title="Nome do paciente">{patient.name}</td>
								<td title="CPF" className="text-nowrap">
									{formatIdentifier(patient.cpf)}
								</td>
								<td title="Dt. Nasc." className="text-center">
									{dayjs(patient.birthdate).format("DD/MM/YYYY")}
								</td>
								<td title="Sexo" className="text-center">
									{patient.gender}
								</td>
								<td title="Endereço" className="text-center text-uppercase">
									{formatPatientAddress(street, houseNumber, neighborhood, city, state, zipCode)}
								</td>
								<td title="Classificação" className="text-center">
									{item.riskClassification.name}
								</td>
								<td
									title="Data do primeiro sintomas"
									className="text-center text-nowrap"
								>
									{formattedSymptomDate}
								</td>
								<td title="Notificação" className="text-center">
									{item.notification.name}
								</td>
							</tr>
						);
					})
				) : (
					<TableSkeletons numberOfCells={9} height={20} numberOfRows={10} />
				)}
			</tbody>
		</Table>
	);
}
